import { render } from "./header-link.vue?vue&type=template&id=0e29d8a6&scoped=true&ts=true"
import script from "./header-link.vue?vue&type=script&lang=ts"
export * from "./header-link.vue?vue&type=script&lang=ts"

import "./header-link.vue?vue&type=style&index=0&id=0e29d8a6&lang=scss&scoped=true"

import exportComponent from "C:\\Build\\vsts-agent-win-x64-3.218.0\\_work\\1\\s\\Connect\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e29d8a6"]])

export default __exports__